module.exports = __webpack_public_path__ + "static/media/varie6a.b98d2f14.jpg";